var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"floating-whatsapp no-print"},[_c('a',{attrs:{"href":"https://wa.me/523320520077","target":"_blank"}},[_c('v-avatar',{attrs:{"color":"#73C160","size":"60"}},[_c('img',{attrs:{"src":require("../../public/iconos/whatsapp-success.svg"),"alt":"whatsapp"}})])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }